import { Box, BoxStyleProps } from '@frontend/ui-library';
import cx from 'classnames';

import { ReactComponent as BtcIcon } from '@frontend/assets/tickers/btc.svg';
import { ReactComponent as EthIcon } from '@frontend/assets/tickers/eth.svg';
import { ReactComponent as UsdcIcon } from '@frontend/assets/tickers/usdc.svg';
import { ReactComponent as DashIcon } from '@frontend/assets/tickers/dash.svg';
import { ReactComponent as EgldIcon } from '@frontend/assets/tickers/egld.svg';
import { ReactComponent as SuiIcon } from '@frontend/assets/tickers/sui.svg';
import { ReactComponent as BnbIcon } from '@frontend/assets/tickers/bnb.svg';
import { ReactComponent as SolIcon } from '@frontend/assets/tickers/sol.svg';

import styles from './OverlapTickers.module.css';
import { useFeatureFlag } from '../../context/FeatureFlagContext';
import { ApiCurrencySymbols, isFlaggedCurrencyVisible } from '../../utils';

const tickers = [
  { symbol: ApiCurrencySymbols.BTC, Icon: BtcIcon },
  { symbol: ApiCurrencySymbols.ETH, Icon: EthIcon },
  { symbol: ApiCurrencySymbols.USDC, Icon: UsdcIcon },
  { symbol: ApiCurrencySymbols.SOL, Icon: SolIcon },
  { symbol: ApiCurrencySymbols.BNB, Icon: BnbIcon },
  { symbol: ApiCurrencySymbols.SUI, Icon: SuiIcon },
  { symbol: ApiCurrencySymbols.EGLD, Icon: EgldIcon },
  { symbol: ApiCurrencySymbols.DASH, Icon: DashIcon },
] as const;

interface OverlapTickersProps extends BoxStyleProps {
  className?: string;
}

export default function OverlapTickers({
  className,
  ...boxStyleProps
}: OverlapTickersProps) {
  const { featureFlags } = useFeatureFlag();
  const visibleTickers = tickers.filter(({ symbol }) =>
    isFlaggedCurrencyVisible(symbol, featureFlags)
  );

  return (
    <Box
      className={cx(styles['base'], className)}
      data-test-id="overlap-tickers"
      {...boxStyleProps}
    >
      {visibleTickers.map(({ symbol, Icon }, index) => (
        <span
          key={symbol}
          className={styles['ticker']}
          aria-label={symbol}
          style={{ zIndex: visibleTickers.length - index }}
        >
          <Icon className={styles['icon']} />
        </span>
      ))}
    </Box>
  );
}
